import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: CampaignCategory = {
  CampaignCategoryID: null,
  TenantID: null,
  CategoryName: '',
  WebUiPosition: null,
  iconImageUrl: '',
  campaigns: [],
  Name: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Name: null
  },
  translations: {
    Name: null,
    LanguageCode: null
  }
}
export const campaignCategorySlice = createSlice({
  name: 'campaignCategory',
  initialState,
  reducers: {
    setCampaignCategoryInfo: (
      state,
      action: PayloadAction<CampaignCategory>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    setCampaignCategorySelectedTranslations: (
      state,
      action: PayloadAction<SetCategoryTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Name: action.payload.translations?.Name ?? null,
          LanguageCode: action.payload.selectedLanguage
        }
      }
    }
  }
})
export const {
  setCampaignCategoryInfo,
  setCampaignCategorySelectedTranslations
} = campaignCategorySlice.actions
export const campaignCategoryReducer = campaignCategorySlice.reducer
